import styled from 'styled-components';
import { breakpoints } from '../../../../styles/screenSizes';

export const Wrapper = styled.section`
    margin-top: 102px;

    @media only screen and (max-width: ${breakpoints.sm}) {
        margin-top: 60px;
    }
`;

export const Container = styled.div`
    max-width: 1280px;
    margin: 0 auto;
    padding: 0px 24px;

    @media only screen and (max-width: ${breakpoints.sm}) {
        padding: 0px 16px;
    }
`;
